import React from 'react';

import { bemCssModules, getTestId } from '@utils';

import Spinner from '@components/Spinner';

import style from './Button.scss';

const cn = bemCssModules(style, 'Button');
const ti = getTestId('Button');

export type TButton = {
  className?: string;
  isLoading?: boolean;
  outline?: boolean;
  testId?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button: React.FC<TButton> = props => {
  const {
    className,
    children,
    isLoading,
    disabled,
    outline,
    type = 'button',
    testId,
    ...rest
  } = props;

  const isDisabled = disabled || isLoading;

  return (
    <button
      /* eslint-disable-next-line react/button-has-type */
      type={type}
      data-testid={ti(testId)}
      className={cn({ disabled, isLoading, outline }, [className])}
      disabled={isDisabled}
      {...rest}
    >
      {isLoading ? (
        <Spinner className={cn('loader')} color="var(--color-main-bg)" size={24} />
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
